import React, { useEffect, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useNavigate } from "react-router-dom"
import {
  Button,
  Card,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  PopoverBody,
  Row,
  UncontrolledPopover,
} from "reactstrap"
import UpdateTable from "../../../components/Common/UpdatedTable"
import moment from "moment"
import action from "../../../assets/icons/action.svg"
import { updatePOStatus } from "../../../services/procurement/purchaseOrder"
import { toastError, toastSuccess } from "../../../helpers/msg_helper"
import { createSelector } from "reselect"
import { useSelector } from "react-redux"
import DNVoucherFilter from "./filter"
import {
  CancelFinanceVoucherEntry,
  deleteFinanceVoucherEntry,
  fetchFinanceVoucherEntrySearch,
  updatePOVoucherStatus,
} from "../../../services/finance/finance"
import { capitalize } from "lodash"

const MaterialInSearch = ({ fromDashboard, onSelect }) => {
  const companyname = localStorage.getItem("companyname")
  document.title = `Material In${
    companyname ? ` | ${companyname}` : "MEP -Hub"
  }`

  const selectLoginState = state => state.Login
  const LoginProperties = createSelector(selectLoginState, login => ({
    loggedUser: login.loggedUser,
  }))

  const { loggedUser } = useSelector(LoginProperties)

  const [purchaseOrderLi, setPurchaseOrderLi] = useState()
  const [status, setStatus] = useState("")
  const [search, setSearch] = useState("")
  const [page, setPage] = useState("")
  const [refresh, setRefresh] = useState(0)
  const [country, setCountry] = useState("")
  const [mrno, setMRNo] = useState("")
  const [poNO, setPONO] = useState("")
  const [refId, setRefId] = useState("")
  const [datefrom, setDatefrom] = useState("")
  const [dateto, setDateto] = useState("")
  const [projectName, setProjectName] = useState("")
  const [financial, setFinancial] = useState(true)
  const [confirmModal, setConfirmModal] = useState(false)
  const [confirmType, setConfirmType] = useState("")
  const [selectedId, setSelectedId] = useState(null)
  const navigate = useNavigate()

  const handlePaginate = page => {
    setPage(page)
  }

  useEffect(() => {
    const fetchMaterialRequest = async () => {
      const response = await fetchFinanceVoucherEntrySearch({
        params: `${
          fromDashboard
            ? `&status=0`
            : status == "0" || status == "1"
            ? `&status=${status}`
            : ""
        }${search ? `&searchText=${search}` : "&searchText"}${
          page ? `&page=${page}` : ""
        }${datefrom ? `&from_date=${datefrom}` : ""}${
          dateto ? `&to_date=${dateto}` : ""
        }${`&sizePerPage=16`}${`&voucher_type=10`}${
          refId ? `&ref_id=${refId}` : ""
        }`,
      })
      setPurchaseOrderLi(response)
    }
    fetchMaterialRequest()
  }, [
    refresh,
    status,
    search,
    page,
    mrno,
    poNO,
    datefrom,
    dateto,
    projectName,
    financial,
    fromDashboard,
    refId,
  ])

  const handleStatusChange = id => {
    setStatus(id)
    setPage(1)
  }
  const handleSearchChange = data => {
    setSearch(data)
    setPage(1)
  }

  const handleCountryChange = id => {
    setCountry(id)
    setPage(1)
  }

  const handleRequestChange = id => {
    setMRNo(id)
    setPage(1)
  }

  const handlePOChange = id => {
    setPONO(id)
    setPage(1)
  }

  const handleProjectName = id => {
    setProjectName(id)
    setPage(1)
  }

  const handleRefChange = id => {
    setRefId(id)
    setPage(1)
  }

  const handleDateChange = (fromdate, todate) => {
    setDatefrom(fromdate)
    setDateto(todate)
    setPage(1)
  }

  const handleFinacialChange = id => {
    setFinancial(id)
    setPage(1)
  }

  const handleDelete = async id => {
    try {
      const deleteResponse = await deleteFinanceVoucherEntry(id)
      toastSuccess(deleteResponse?.message)
      setRefresh(refresh + 1)
    } catch (err) {
      toastError(err?.message)
    }
  }
  const handleCancel = async id => {
    try {
      const deleteResponse = await CancelFinanceVoucherEntry(id)
      setRefresh(refresh + 1)
    } catch (err) {
      toastError(err?.message)
    }
  }

  const handleApprove = async id => {
    try {
      const updateResponce = await updatePOVoucherStatus({
        params: { id: id, status: confirmType == "approve" ? 2 : 0 },
      })
      toastSuccess(updateResponce?.message)
      setRefresh(refresh + 1)
    } catch (err) {
      toastError(err?.message)
    }
  }

  const handleActivate = id => {
    const updateStatus = async id => {
      try {
        const response = await updatePOStatus(id)
        toastSuccess(response?.message)
      } catch (err) {
        toastError(err?.message)
      }
      setRefresh(refresh + 1)
    }
    updateStatus(id)
  }

  const columns = [
    {
      label: "Refernce No",
      renderCell: item =>
        fromDashboard ? (
          item?.code
        ) : (
          <div
            onClick={() => navigate(`/inventory-voucher/view/${item?.id}`)}
            className="pointer fw-bold"
          >
            {" "}
            {item?.ref_number}{" "}
          </div>
        ),
    },
    {
      label: "Voucher",
      renderCell: item =>
        item?.voucher_type?.voucher_type
          ? item?.voucher_type?.voucher_type
          : "-",
    },
    {
      label: (
        <div className={fromDashboard ? "text-end pe-5" : ""}>
          {fromDashboard ? "Amount" : "Created By"}
        </div>
      ),
      renderCell: item => (
        <div className={fromDashboard ? "text-end pe-5" : ""}>
          {fromDashboard
            ? item?.amount
              ? item?.amount
              : 0
            : item?.created_by?.name
            ? capitalize(item?.created_by?.name)
            : "-"}
        </div>
      ),
    },
    {
      label: "Date",
      renderCell: item => moment(item?.date).format("DD-MMM-YYYY"),
    },

    {
      label: "Status",
      renderCell: item => (
        <div>
          <span
            className={`font-13 ${
              item?.voucher_id == 16 && item?.status == 1
                ? "status-draft"
                : item?.voucher_id == 16 && item?.status == 2
                ? "status-active"
                : item?.voucher_id == 16 && item?.status == 0
                ? "status-inactive"
                : item?.custom_status === 1
                ? "status-active"
                : "status-inactive"
            }`}
          >
            {item?.voucher_id == 16 && item?.status == 1
              ? "New"
              : item?.voucher_id == 16 && item?.status == 2
              ? "Approved"
              : item?.voucher_id == 16 && item?.status == 0
              ? "Rejected"
              : item?.custom_status === 1
              ? "Active"
              : "Inactive"}
          </span>
        </div>
      ),
    },
    {
      label: "Action",
      renderCell: item =>
        fromDashboard ? (
          <Button
            color={"primary"}
            className={"px-2 py-0 fs-13 btn btn-primary"}
            onClick={() => onSelect(item)}
          >
            Select
          </Button>
        ) : (
          <>
            <div>
              <span id={`PopoverLegacy-${item?.id}`}>
                <img src={action} alt="" className="pointer" />
              </span>
            </div>
            <UncontrolledPopover
              placement="bottom"
              target={`PopoverLegacy-${item?.id}`}
              trigger="legacy"
            >
              <PopoverBody>
                <>
                  {item?.custom_status == 1 && (
                    <>
                      <div
                        className="table-popup-content"
                        onClick={() =>
                          navigate(`/inventory-voucher/edit/${item?.id}`)
                        }
                      >
                        Edit
                      </div>
                    </>
                  )}
                  {item?.custom_status !== 0 && item?.status != 0 && (
                    <div
                      className="table-popup-content"
                      onClick={() => {
                        setSelectedId(item?.id)
                        setConfirmType("cancel")
                        setConfirmModal(true)
                      }}
                    >
                      Cancel
                    </div>
                  )}
                  <div
                    className="table-popup-content"
                    onClick={() => {
                      setSelectedId(item?.id)
                      setConfirmType("delete")
                      setConfirmModal(true)
                    }}
                  >
                    Delete
                  </div>
                </>
              </PopoverBody>
            </UncontrolledPopover>
          </>
        ),
    },
  ]

  return (
    <React.Fragment>
      <div
        className={`${
          fromDashboard ? "pt-0 dashboard-page-content-view" : "page-content"
        }`}
      >
        <div className="container-fluid">
          {!fromDashboard ? (
            <div className="d-flex justify-content-between">
              <Breadcrumbs
                title="Inventory"
                breadcrumbObject={[
                  { title: "Inventory", link: "/inventory" },
                  {
                    title: "Material In",
                    link: "/inventory-material-in",
                  },
                ]}
              />
              {loggedUser?.permission?.some(
                permissionItem => permissionItem?.name === "materialin_create"
              ) && (
                <div
                  onClick={() =>
                    navigate(`/inventory-voucher/add`, {
                      state: { id: 19, type: "from_mi", chkField: "MI" },
                    })
                  }
                  className={"px-2 mb-3 me-2 btn btn-primary"}
                >
                  {"+ Material In"}
                </div>
              )}
            </div>
          ) : (
            <></>
          )}
          <Card className="me-2 px-2 pb-2">
            {!fromDashboard ? (
              <>
                <DNVoucherFilter
                  handleStatusChange={handleStatusChange}
                  handleSearchChange={handleSearchChange}
                  handleCountryChange={handleCountryChange}
                  handleRequestChange={handleRequestChange}
                  handleDateChange={handleDateChange}
                  handleProjectName={handleProjectName}
                  handleFinacialChange={handleFinacialChange}
                  handlePOChange={handlePOChange}
                  handleRefChange={handleRefChange}
                  sampleUrl={"download/suppliers.xlsx"}
                  importUrl={"suppliers/import"}
                  isImport={false}
                />
                <hr className="table-divide" />
              </>
            ) : (
              <></>
            )}
            <Row className="mt-2 ever-rise-table">
              <Col xs={12}>
                {purchaseOrderLi && (
                  <UpdateTable
                    className="mt-5"
                    nodes={purchaseOrderLi?.data?.data}
                    paginate={purchaseOrderLi?.data}
                    columns={columns}
                    CurrentPage={page}
                    handlePagination={handlePaginate}
                    tableWidth="20% 25% 25% 10% 10% 10%"
                    mobileWidth="40% 40% 40% 40% 30%"
                  />
                )}
              </Col>
            </Row>
          </Card>
        </div>
        <Modal isOpen={confirmModal} toggle={() => setConfirmModal(false)}>
          <ModalHeader toggle={() => setConfirmModal(false)}>
            {confirmType === "delete"
              ? "Delete Confirmation"
              : confirmType == "cancel"
              ? "Confirmation"
              : confirmType == "approve"
              ? "Approve Confirmation"
              : "Reject Confirmation"}
          </ModalHeader>
          <ModalBody>
            Are you sure you want to {confirmType} this entry?
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={() => setConfirmModal(false)}>
              No
            </Button>
            <Button
              color="primary"
              onClick={async () => {
                if (confirmType === "delete") {
                  await handleDelete(selectedId)
                } else if (confirmType === "cancel") {
                  await handleCancel(selectedId)
                } else if (confirmType === "approve") {
                  await handleApprove(selectedId)
                } else if (confirmType === "reject") {
                  await handleApprove(selectedId)
                }
                setConfirmModal(false)
              }}
            >
              Yes
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </React.Fragment>
  )
}

export default MaterialInSearch
